<template>

	<div>
		<section id="catalog" class="catalog1">

			<div class="container-fluid ">
				<br>

				<div class="catalog input-container">
					<input
									type="text"
									class="form-control"
									v-model="search"
									placeholder="Поиск..."
									@input="getResults()"
					/>
					<div
									class="clear-icon"
									v-if="search"
									@click="search='';getResults()"
									title="Очистить"
					></div>
				</div>

				<br><br>
				<div class="row">
					<div class="col-md-2 col-lg-3 col-sm-12">
						<h4>Система</h4>
						<v-select
										label="label"
										:options="system_list"
										:reduce="(option) => option.id"
										v-model="system"
						>
						</v-select>
						<br>
						<hr>
						<h4>Категории</h4>
						<div class="categories-container">
							<div
											class="category-card"
											:class="{ active: menu_right === 0 }"
											@click="this.id = 0; getResults(); menu_right = 0"
							>
								Все
							</div>
							<div v-if="cat" v-for="item in cat" :key="item.id">
								<div
												class="category-card"
												:class="{ active: menu_right === item.id }"
												@click="this.id = item.id; getResults(); menu_right = item.id"
								>
									{{ item.label }}
								</div>
							</div>
						</div>

					</div>
					<div class="col-md-10 col-lg-9 col-sm-12">
<!--						<div class="row between">-->
<!--							<div class="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12   block" v-if="app.data && app.data.length>0" v-for="(item,key) in app.data">-->
<!--								<div class="color life-situations__item  central">-->
<!--									<router-link-->
<!--													:to="{-->
<!--														name: 'details',-->
<!--														params: {-->
<!--															id: item.id,-->
<!--															app_ver_id: item.latest_app.id,-->
<!--															system: system-->
<!--														}-->
<!--													}"-->
<!--																									class="app-link"-->
<!--									><img :src="item.latest_app.icon" class="product-image">-->
<!--										<div class="text-h3">-->
<!--											<br>-->
<!--											<h3>{{ item.name }}</h3>-->
<!--											<br>-->
<!--										</div>-->
<!--										&lt;!&ndash;						<h6>{{item.description.slice(0, 40)}}</h6>&ndash;&gt;-->
<!--									</router-link>-->
<!--								</div>-->
<!--							</div>-->
<!--						</div>-->
						<div class="popular-apps">
							<div class="container">
						<div class="apps-grid">
							<div v-if="app.data && app.data.length>0"
											class="app-card"
											v-for="app in app.data"
											:key="app.id"
							>
								<a :href="'/appdetail/' + app.id +'/' +app.latest_app.id  +'/' + system">

									<div class="app-icon">
										<img :src="app.latest_app.icon" alt="Иконка приложения">
									</div>
									<div class="app-info">
										<h3>{{ app.name }}</h3>
										<div class="app-stats">
											<span><i class="fas fa-download"></i> {{ app.download_count }}</span>
											<span><i class="fas fa-star"></i> {{ app.stars }}</span>
										</div>
<!--										<div class="app-system">Доступно для Аврора {{ app.systems }}</div>-->

										<p class="app-description "><span v-html=" truncateDescription(app.latest_app.description)"></span></p>
									</div>
								</a>
							</div>
						</div>
						</div>
						</div>

						<br><br>
						<div class="card-footer">
							<div class="row">
								<div class="col">

									<pagination :data="app" @pagination-change-page="getResults" :limit="2">
										<!--									<span slot="prev-nav">&lt; Назад</span>-->
										<!--									<span slot="next-nav">Вперед &gt;</span>-->
									</pagination>
								</div>
								<div class="col">
									<select class="form-control" v-model="pagination" @change="getResults">
										<option value="8">8</option>
										<option value="12">12</option>
										<option value="20">20</option>
										<option value="50">50</option>
										<option value="96">100</option>
										<option value="all">Все</option>
									</select>
								</div>
							</div>
						</div>

					</div>
				</div>
			</div>
		</section>

		<div class="warning warning--active " v-show="banner">
			<div class="warning__text">Данный сайт использует куки, нажимая на кнопку <b>Принимаю</b>, вы соглашаетесь на их использование,
				а также принимаете <a href="/lic" class=" aboutlink ">"СОГЛАШЕНИЕ ОБ ИСПОЛЬЗОВАНИИ МАРКЕТА "</a> .
			</div>
			<div class="warning__text ">
				<button class="btn btn-outline-success" type="button" @click="button_baner()">Принимаю</button>
			</div>
		</div>


	</div>

</template>
<script>
export default {
	props  : [
		'user_id'
	],
	data   : () => ({
		cat         : {},
		app         : {},
		sort        : {},
		system_list : [],
		system      : '',
		id          : 0,
		search      : '',
		pagination  : 20,
		current_page: 1,
		sortable    : '',
		total       : 0,
		name        : null,
		banner      : true,
		menu_right  : 0,
		urls        : {
			cat      : "/api/site/category/",
			app      : "/api/site/app?page=",
			getsystem: "/api/system/any",
			role     : "/api/user/role"
		},
		token       : document.head.querySelector('meta[name="csrf-token"]'),
	}),
	methods: {
		truncateDescription(desc) {
			return desc.length > 60 ? desc.substring(0, 60) + '...' : desc;
		},
		button_baner() {
			this.banner = false;
			this.setCookie('banner', 1)
		},
		setCookie(name, value) {
			document.cookie = name + '=' + value + ';path=/';
		},
		getCookie(name) {
			const value = `; ${document.cookie}`;
			const parts = value.split(`; ${name}=`);
			if (parts.length === 2) {
				return parts.pop().split(';').shift();
			}
			return null;
		},
		getCat() {
			axios.get(this.urls.cat + this.system)
							.then(({data}) => (
											this.cat = data
							));
		},
		async getResults(page, sort) {
			if (page === undefined) {
				page = this.current_page;
			} else {
				this.current_page = page;
			}
			this.system = Number(this.getCookie('system'));
			axios.get(this.urls.app + page, {
				params : {
					id        : this.id,
					sortable  : this.sortable,
					search    : this.search,
					system    : this.system,
					user_id   : this.user_id,
					pagination: this.pagination
				},
				headers: {
					"X-CSRF-TOKEN": this.token.content,
				}
			})
							.then(({data}) => (
											this.app = data
							));
		},
		async getSystem() {
			axios.get(this.urls.getsystem)
							.then(({data}) => (
											this.system_list = data
							))
							.catch((errors) => {
								this.toastError(errors.response.data.errors);
							});
		},
		init() {
			this.getSystem();

			var banner = this.getCookie('banner');
			if (banner !== null) {
				this.banner = false;
			}

			this.getResults();
			var system = this.getCookie('system');
			if (system !== null) {
				this.system = Number(system);
			} else {
				this.system = 1;
			}
			this.getCat();
		}
	},
	mounted() {
		document.title = 'Программы для Авроры';
		//this.getImage();
		this.init();
	},
	watch: {
		system: function (newValue) {
			this.setCookie('system', this.system);
			this.getResults();
			this.getCat();
		},
	},
}
</script>
<style>


.life-situations__item {
	padding: 0.5em 0 0 0;
	background-color: #fff; /* Цвет фона карточки */
	border-radius: 10px; /* Округление углов */
	box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); /* Тень для карточки */
	transition: transform 0.3s, box-shadow 0.3s; /* Плавный переход */
	overflow: hidden; /* Скрыть контент, выходящий за границы */
	width: 140px;
	min-width: 140px;
	max-width: 140px;
}

.life-situations__item:hover {
	background-color: #d6e0fb;
	transform: translateY(-5px); /* Подъем карточки при наведении */
	box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2); /* Увеличенная тень при наведении */
}

.product-image {
	width: 100%; /* Адаптивная ширина */
	height: auto; /* Авто высота для сохранения пропорций */
	border-top-left-radius: 10px; /* Округление верхнего левого угла */
	border-top-right-radius: 10px; /* Округление верхнего правого угла */
}

.life-situations__item .text-h3 {
	padding: 15px; /* Отступы внутри блока с текстом */
	text-align: center; /* Центрирование текста */
}

.life-situations__item .text-h3 h3 {
	font-size: 1rem; /* Размер шрифта заголовка */
	color: #333; /* Цвет текста заголовка */
	margin: 0; /* Убираем стандартные отступы */
}

.active_green {
	background-color: #d6e0fb;
	color: #333;
	width: inherit;
	border-color: #d3dffc; /* Цвет границы для активного элемента */
}

.menu:hover {
	background-color: #d6e0fb;
	color: #333;
}

a {
	text-decoration: none
}

a:hover {
	text-decoration: none;
}


/* Меню категории */
.categories-container {
	display: flex;
	flex-wrap: wrap;
	gap: 0.7em;
	margin-bottom: 1em;
}

.category-card {
	background: #fff;
	border-radius: 12px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
	padding: 0.7em 1.2em;
	font-size: 1em;
	color: #333;
	cursor: pointer;
	transition: box-shadow 0.2s, background 0.2s, color 0.2s;
	margin-bottom: 0.3em;
	border: 1px solid transparent;
	user-select: none;
	white-space: nowrap;
}

.category-card.active,
.category-card:hover {
	background: #e3eaff;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.10);
	color: #2a3fa0;
	border: 1px solid #aebcf7;
}

.apps-grid {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
	gap: 25px;
}

.app-card {
	background: white;
	border-radius: 8px;
	overflow: hidden;
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
	transition: transform 0.3s, box-shadow 0.3s;
	cursor: pointer;
}

.app-card:hover {
	transform: translateY(-5px);
	box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.app-icon {
	height: 120px;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #f5f5f5;
}

.app-icon img {
	max-width: 80px;
	max-height: 80px;
	border-radius: 16px;
}

.app-info {
	padding: 15px;
}

.app-info h3 {
	margin: 0 0 10px 0;
	font-size: 16px;
	color: #2c3e50;
}

.app-rating {
	color: #f1c40f;
	margin-bottom: 8px;
}

.app-rating .filled {
	color: #f39c12;
}

.app-system {
	color: #71a9b7;
	margin-bottom: 8px;
	font-size: 14px;
}



.app-category {
	color: #7f8c8d;
	font-size: 14px;
	margin: 0;
}

.app-stats {
	display: flex;
	justify-content: space-between;
	margin-bottom: 10px;
	font-size: 14px;
	color: #7f8c8d;
}

.app-description {
	font-size: 14px;
	color: #555;
	margin: 0;
	line-height: 1.4;
}

@media (max-width: 1300px) {
	.categories-container {
		flex-direction: row;
		overflow-x: auto;
	}
}

@media (max-width: 768px) {
	.categories-container {
		flex-direction: row;
		overflow-x: auto;
	}

	.catalog.input-container input.form-control {
		height: 32px;
		font-size: 14px;
		padding: 6px 35px 6px 35px;
	}

	.catalog.input-container {
		width: 100%;
		max-width: 100%;
		margin: 0 0 1em 0;
	}
}

@media (min-width: 769px) {
	.categories-container {
		flex-direction: column;
	}
}

.warning {
	position: fixed;
	bottom: 0;
	left: 0;
	display: none;
	justify-content: center;
	width: 100%;
	padding: 30px;
	box-sizing: border-box;
	background-color: #d6e0fb;
}

.warning--active {
	display: flex;
}

.warning__text {
	margin-right: 30px;
}


.warning__read {
	display: block;
	margin-left: 15px;
}
</style>
